import {connect} from "@planetscale/database";

export const CATEGORY_IDS = ['0JQ5DAqbMKFQ00XGBls6ym', '0JQ5DAqbMKFEC4WFtoNRpw', '0JQ5DAqbMKFBweu2euf3Sj', '0JQ5DAqbMKFLVaM30PMBm4', '0JQ5DAudkNjCgYMM0TZXDr',
    '0JQ5DAqbMKFxXaXKP7zcDp', '0JQ5DAqbMKFzHmL4tf05da', '0JQ5DAqbMKFHOzuVTgTizF', '0JQ5DAqbMKFDXXwE9BDJAr', '0JQ5DAqbMKFCWjUTdzaG0e',
    '0JQ5DAqbMKFAXlCG6QvYQ4', '0JQ5DAqbMKFEZPnFQSFB1T', '0JQ5DAqbMKFNQ0fGp4byGU', '0JQ5DAqbMKFGvOw3O4nLAf', '0JQ5DAqbMKFFzDl7qN9Apr',
    '0JQ5DAqbMKFCuoRTxhYWow', '0JQ5DAqbMKFA6SOHvT3gck', '0JQ5DAqbMKFP9UNkavIGrM', '0JQ5DAqbMKFJKoGyUMo2hE', '0JQ5DAqbMKFx0uLQR2okcc',
    '0JQ5DAqbMKFIVNxQgRNSg0', '0JQ5DAqbMKFFtlLYUHv8bT', '0JQ5DAqbMKFAUsdyVjCQuL', '0JQ5DAqbMKFDkd668ypn6O', '0JQ5DAqbMKFAJ5xb0fwo9m',
    '0JQ5DAqbMKFQIL0AXnG5AK', '0JQ5DAqbMKFPw634sFwguI', '0JQ5DAqbMKFOOxftoKZxod', '0JQ5DAqbMKFPrEiAOxgac3', '0JQ5DAqbMKFy78wprEpAjl',
    '0JQ5DAqbMKFCbimwdOYlsl', '0JQ5DAqbMKFIpEuaCnimBj', '0JQ5DAqbMKFEOEBCABAxo9', '0JQ5DAqbMKFFoimhOqWzLB', '0JQ5DAqbMKFJw7QLnM27p6',
    '0JQ5DAqbMKFCfObibaOZbv', '0JQ5DAqbMKFLb2EqgLtpjC', '0JQ5DAqbMKFAjfauKLOZiv', '0JQ5DAqbMKFLjmiZRss79w', '0JQ5DAqbMKFKLfwjuJMoNC',
    '0JQ5DAqbMKFQiK2EHwyjcU', '0JQ5DAqbMKFQ1UFISXj59F', '0JQ5DAqbMKFAQy4HL4XU2D', '0JQ5DAqbMKFObNLOHydSW8', '0JQ5DAqbMKFSCjnQr8QZ3O',
    '0JQ5DAqbMKFI3pNLtYMD9S', '0JQ5DAqbMKFFsW9N8maB6z', '0JQ5DAqbMKFF9bY76LXmfI', '0JQ5DAqbMKFRKBHIxJ5hMm', '0JQ5DAqbMKFGnsSfvg90Wo',
    '0JQ5DAqbMKFLYQVFHcXMae', '0JQ5DAqbMKFDBgllo2cUIN', '0JQ5DAqbMKFOzQeOmemkuw', '0JQ5DAqbMKFziKOShCi009', '0JQ5DAqbMKFRieVZLLoo9m',
    '0JQ5DAqbMKFRY5ok2pxXJ0', '0JQ5DAqbMKFImHYGo3eTSg'];

export function getDbConnection() {
    const config = {
        host: 'aws.connect.psdb.cloud',
        username: 'e79daxp5p51oqpk0lf9q',
        password: 'pscale_pw_wT8TCoQKTHS1wIymT9KK1gwArshSxQIMuvF5uqWGQj1'
    }

    return connect(config);
}

export async function getTable(tableName) {
    const db = await getDbConnection();

    return await db.execute(`SELECT * FROM ${tableName}`);
}

export async function insertArtistPlaylistData(data) {

    let queryString = '';

    for (let i = 0; i < data.length; i++) {
        const separator = i > 0 ? ', ' : '';
        const item = data[i];

        if (item !== undefined) {
            queryString = queryString + `${separator}("${item.playlist_id}", "${item.artist_id}")`
        }
    }

    const db = await getDbConnection();

    return await db.execute(`INSERT INTO artistPlaylistData (playlistId, artistId) VALUES ${queryString}`);
}

export async function getScore(artistId) {
    const mostVisibilityRow = await getMostVisibleRow();
    const mostVisibilityRowCount = mostVisibilityRow.occurrences;

    const currentVisibilityRow = await getArtistVisibilityCount(artistId);
    const currentVisibilityRowCount = currentVisibilityRow.occurrences;

    return ((currentVisibilityRowCount / mostVisibilityRowCount) * 100);
}

export async function getMostVisibleRow() {
    const db = await getDbConnection();
    const row = await db.execute('SELECT artistId, COUNT(*) AS occurrences FROM artistPlaylistData GROUP BY artistId ORDER BY occurrences DESC LIMIT 1;');

    return await row.rows[0] ?? null;
}

export async function getArtistVisibilityCount(artistId) {
    const db = await getDbConnection();
    const row = await db.execute(`SELECT COUNT(*) AS occurrences FROM artistPlaylistData WHERE artistId = "${artistId}";`);

    return await row.rows[0] ?? null;
}

export async function deleteArtistPlaylistDataDuplicates() {
    const db = await getDbConnection();

    return await db.execute(`
        DELETE t1
        FROM artistPlaylistData AS t1, artistPlaylistData AS t2
        WHERE t1.id > t2.id
        AND t1.playlistId = t2.playlistId
        AND t1.artistId = t2.artistId;
    `);
}

export async function executeQuery(queryString) {
    const db = await getDbConnection();

    return await db.execute(queryString);
}
